export default {
  productPriceBreaks: [],
  productPriceBreak: undefined,
};
